// noinspection JSUnusedGlobalSymbols

export default class Viewport {
    static get dimensions() {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        return {
            width: width,
            height: height,
            aspectRatio: width / height
        };
    };

    static get orientation() {
        const viewport = Viewport.dimensions;
        return viewport.width > viewport.height ? 'landscape' : 'portrait';
    };
}